import { render, staticRenderFns } from "./TheSideNav.vue?vue&type=template&id=20c0347f&scoped=true"
import script from "./TheSideNav.vue?vue&type=script&lang=js"
export * from "./TheSideNav.vue?vue&type=script&lang=js"
import style0 from "./TheSideNav.vue?vue&type=style&index=0&id=20c0347f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c0347f",
  null
  
)

export default component.exports